import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { FeatureCards } from '@/components/home/FeatureCards'
import { HomeFaq } from '@/components/home/HomeFaq'
import { PlateHero } from '@/components/home/PlateHero'
import { PLATE_ERROR, isValidPlate } from '@/lib/plate'
import { rememberConsultation, track } from '@/lib/measurement'

/**
 * A home vende a consulta, não um plano: não há tabela de preços aqui. O hero
 * só confere o formato da placa e manda para /consulta/:placa — é aquela página
 * que chama a API, mostra a prévia e converte.
 */
export function Home() {
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)
  const [navigating, setNavigating] = useState(false)

  function handleSubmit(plate: string) {
    if (!isValidPlate(plate)) {
      setError(PLATE_ERROR)
      return
    }
    setError(null)
    setNavigating(true)
    rememberConsultation(plate)
    track('plate_submit')
    navigate('/consulta')
  }

  return (
    <>
      <PlateHero onSubmit={handleSubmit} loading={navigating} error={error} />
      <FeatureCards />
      <HomeFaq />
    </>
  )
}
